module.exports = __webpack_public_path__ + "static/media/NotoSansCJKtc-Regular.9350cea3.woff";